import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import copy from 'copy-to-clipboard'
import {
  Wrapper,
  Title,
  Description,
  Footer,
  Banner,
  BannerImg,
  BannerText,
  ReferalBlock,
  ReferalBlockEmoji,
  ReferalBlockTitle,
  ReferalBlockHeader
} from './styles'

import ModalContainer from '../../Container'
import Button from 'components/Buttons'
import Input from 'components/Input'

// assets
import BannerUrl from './assets/banner.png'
import ChainImage from './assets/chain.webp'

// state
import ModalState from '../../ModalState'
import ConfettiState from 'components/ConfettiSystem/ConfettiState'

interface props {
  nickname: string;
}

export default function WhitelistModal({ nickname }: props) {

  const { t, i18n } = useTranslation()

  useEffect(() => {
    ConfettiState.show = true;
  }, [])

  return (
    <ModalContainer size="normal">

      <Wrapper>

        <Banner>
          <BannerImg src={BannerUrl} />
          <BannerText>{t("whiltelist.coomingSoon")}</BannerText>
        </Banner>

        <Title>{t("whiltelist.title")}</Title>
        <Description>{t("whiltelist.description")}</Description>

        <ReferalBlock>
          <ReferalBlockHeader>
            <ReferalBlockEmoji src={ChainImage} />
            <ReferalBlockTitle>
              {t("referal.title")}
            </ReferalBlockTitle>
          </ReferalBlockHeader>
          <Input
            value={`${window.location.href}ref/${nickname}`}
            onChange={() => { }}
            height="big"
            disable={true}
            rightElement={
              <Button onClick={() => copy(`${window.location.href}ref/${nickname}`)} variable="solid" height="small" >{t("btns.copy")}</Button>
            }
          />
        </ReferalBlock>

        <Button
          variable="solid"
          height="big"
          onClick={() => ModalState.close()}
        >
          {t("btns.close")}
        </Button>
        <Footer>📦 {t("whiltelist.footer")}</Footer>

      </Wrapper>


    </ModalContainer>
  );
}